import React from "react";
import { useFieldArray, useForm } from "react-hook-form";
import styles from "../auth/signup.module.css";
import InlineLoaderComponent from "../../components/common/InlineLoaderComponent";
import {
  useGetCountryListQuery,
  useGetStateListQuery,
  useGetProfileDdetailQuery,
  useUpdateUserProfileMutation,
} from "../../store/api/profileApi";
import Loader from "../../components/common/Loader";
import { toast } from "sonner";

const EditProfile = () => {
  const {
    data: profileData,
    isLoading: profileDataLoading,
    isFetching: profileDataFetching,
  } = useGetProfileDdetailQuery();
  const {
    register,
    handleSubmit,
    watch,
    control,
    setError,
    formState: { errors },
  } = useForm({
    mode: "onTouched", // or "onChange" or "all"
    reValidateMode: "onChange",

    values: profileData,
  });

  const { data: countryList } = useGetCountryListQuery();
  const [updateProfile, { isLoading: updateProfileLoading }] =
    useUpdateUserProfileMutation();
  const country = watch("country");
  const whitlistCountriesForStateApi = ["USA", "Canada", "India"];
  const selctedCountry = whitlistCountriesForStateApi?.includes(country)
    ? countryList?.find((item) => item.name === country)
    : null;
  const { data: stateList } = useGetStateListQuery(selctedCountry?.id, {
    skip: !selctedCountry,
  });

  const onSubmit = async (formData) => {
    let data = formData;
    const payload = {
      businessName: data.business_name,
      dbaName: data.dba_name,
      ownerName: data.owner_name,
      ownerPhone: data.owner_phone,
      ownerEmail: data.owner_email,
      accountingContactName: data.accounting_contact_name,
      email: data.email,
      address: data.address,
      secondaryAddress: data.secondary_address,
      buildingName: data.building_name,
      city: data.city,
      state: data.state,
      country: data.country,
      postalCode: data.postal_code,
      phone: data.phone,
      fax: data.fax,
      websiteUrl: data.website_url,
      tinGstNumber: data.tin_gst_number,
      resaleCertificateNumber: data.resale_certificate_number,
      govLicenseNumber: data.gov_license_number,
    };
    updateProfile(payload)
      .unwrap()
      .then(() => {
        toast.success("Profile updated successfully");
      })
      .catch((error) => {
        toast.error(error.data.message);
      });
  };

  return (
    <div className="container mb-5">
      {profileDataLoading && <Loader />}
      <form
        onSubmit={handleSubmit(onSubmit)}
        encType="multipart/form-data"
        className="signup-login-form"
      >
        <div>
          {/* <div className={styles.registrationPara}>
            <div className={styles.title}>
              Dear Customer and Business Partner:
            </div>
            <div className={styles.subTitle}>
              I am writing to you to inquire whether you have instituted an
              anti-money laundering (AML) program in compliance with the USA
              PATRIOT Act, the U.S. Bank Secrecy act and other regulatory
              requirements.In order to complete our compliance obligation, we
              are required under our policy and program to acquire the following
              identifying information for all our business partners and
              customers. Please provide the following identifying information.
            </div>
          </div>
          <div className="form-group radio-group">
            <div className="form-radio-option">
              <input
                type="radio"
                id="amlYes"
                value="true"
                {...register("isHaveAmlProgram", {
                  required: "This field is required",
                })}
              />
              <label
                style={{
                  fontSize: "16px",
                  color: "#000",
                  fontWeight: "600",
                  letterSpacing: "0.01rem",
                }}
                htmlFor="amlYes"
              >
                Yes, we have or will be instituting an AML Program.
              </label>
            </div>

            <div className="form-radio-option">
              <input
                type="radio"
                id="amlNo"
                value="false"
                {...register("isHaveAmlProgram", {
                  required: "This field is required",
                })}
              />
              <label
                htmlFor="amlNo"
                style={{
                  fontSize: "16px",
                  color: "#000",
                  fontWeight: "600",
                  letterSpacing: "0.01rem",
                }}
              >
                No, we will not institute an AML program due to our status as an
                "exempt" retailer.
              </label>
            </div>

            {errors.isHaveAmlProgram && (
              <span className="error-message">
                {errors.isHaveAmlProgram.message}
              </span>
            )}
          </div> */}

          <div className="group-container">
            <div className="form-group">
              <label>Business Name*</label>
              <input
                className="form-input"
                type="text"
                {...register("business_name", {
                  required: "Business name is required",
                })}
              />
              {errors.business_name && (
                <span className="error-message">
                  {errors.business_name.message}
                </span>
              )}
            </div>
            <div className="form-group">
              <label>DBA Name</label>
              <input
                className="form-input"
                type="text"
                {...register("dba_name")}
              />
            </div>
          </div>
          <div className="group-container">
            <div className="form-group">
              <label>Owner Name</label>
              <input
                className="form-input"
                type="text"
                {...register("owner_name")}
              />
            </div>

            <div className="form-group">
              <label>Owner Phone</label>
              <input
                className="form-input"
                type="tel"
                {...register("owner_phone", {
                  pattern: {
                    value:
                      /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/,
                    message: "Invalid phone number",
                  },
                })}
              />
              {errors.owner_phone && (
                <span className="error-message">
                  {errors.owner_phone.message}
                </span>
              )}
            </div>

            <div className="form-group">
              <label>Owner Email</label>
              <input
                className="form-input"
                type="email"
                {...register("owner_email", {
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "Invalid email address",
                  },
                })}
              />
              {errors.owner_email && (
                <span className="error-message">
                  {errors.owner_email.message}
                </span>
              )}
            </div>
          </div>
          <div className="form-group">
            <label>User Email*</label>
            <input
              className="form-input"
              type="email"
              {...register("owner_email", {
                required: "Email is required",
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: "Invalid email address",
                },
              })}
            />
            {errors.email && (
              <span className="error-message">{errors.email.message}</span>
            )}
          </div>

          <div className="group-container">
            <div className="form-group">
              <label>Accounting Contact Name</label>
              <input
                className="form-input"
                type="text"
                {...register("accounting_contact_name")}
              />
            </div>

            <div className="form-group">
              <label>Email*</label>
              <input
                className="form-input"
                type="email"
                {...register("email", {
                  required: "Email is required",
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "Invalid email address",
                  },
                })}
              />
              {errors.email && (
                <span className="error-message">{errors.email.message}</span>
              )}
            </div>
            <div className="form-group">
              <label>Phone</label>
              <input
                className="form-input"
                type="tel"
                {...register("phone", {
                  pattern: {
                    value:
                      /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/,
                    message: "Invalid phone number",
                  },
                })}
              />
              {errors.phone && (
                <span className="error-message">{errors.phone.message}</span>
              )}
            </div>
          </div>
          <div className="group-container">
            <div className="form-group">
              <label>Address Line 1*</label>
              <textarea
                className="form-textarea"
                {...register("address", {
                  required: "Address is required",
                })}
              />
              {errors.address && (
                <span className="error-message">{errors.address.message}</span>
              )}
            </div>

            <div className="form-group">
              <label>Address Line 2*</label>
              <textarea
                className="form-textarea"
                {...register("secondary_address")}
              />
              {errors.secondary_address && (
                <span className="error-message">
                  {errors.secondary_address.message}
                </span>
              )}
            </div>
          </div>
          <div className="group-container-grid">
            <div className="form-group">
              <label>Building Name</label>
              <input
                className="form-input"
                type="text"
                {...register("building_name")}
              />
              {errors.building_name && (
                <span className="error-message">
                  {errors.building_name.message}
                </span>
              )}
            </div>

            <div className="form-group">
              <label>City*</label>

              <input
                className="form-input"
                type="text"
                {...register("city", {
                  required: "City is required",
                })}
              />
              {errors.city && (
                <span className="error-message">{errors.city.message}</span>
              )}
            </div>
            <div className="form-group">
              <label>Country*</label>
              <select
                className="form-select"
                {...register("country", {
                  required: "Country is required",
                })}
              >
                <option value="">Select Country</option>
                {countryList?.map((icountry) => (
                  <option key={icountry.name} value={icountry.name}>
                    {icountry.name}
                  </option>
                ))}
              </select>
              {errors.country && (
                <span className="error-message">{errors.country.message}</span>
              )}
            </div>
            <div className="form-group">
              <label>State*</label>
              {selctedCountry ? (
                <select
                  className="form-select"
                  {...register("state", {
                    required: "State is required",
                  })}
                >
                  <option value="">Select State</option>
                  {stateList?.map((istate) => (
                    <option key={istate?.name} value={istate?.name}>
                      {istate?.name}
                    </option>
                  ))}
                </select>
              ) : (
                <input
                  className="form-input"
                  type="text"
                  {...register("state", {
                    required: "State is required",
                  })}
                />
              )}
              {errors.state && (
                <span className="error-message">{errors.state.message}</span>
              )}
            </div>

            <div className="form-group">
              <label>Postal Code*</label>
              <input
                className="form-input"
                type="text"
                {...register("postal_code", {
                  required: "Postal code is required",
                })}
              />
              {errors.postal_code && (
                <span className="error-message">
                  {errors.postal_code.message}
                </span>
              )}
            </div>

            <div className="form-group">
              <label>Fax</label>
              <input
                className="form-input"
                type="tel"
                {...register("fax", {
                  pattern: {
                    value:
                      /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/,
                    message: "Invalid fax number",
                  },
                })}
              />
              {errors.fax && (
                <span className="error-message">{errors.fax.message}</span>
              )}
            </div>

            <div className="form-group">
              <label>Website URL</label>
              <input
                className="form-input"
                type="url"
                {...register("website_url", {
                  pattern: {
                    value:
                      /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/,
                    message: "Invalid URL",
                  },
                })}
              />
              {errors.website_url && (
                <span className="error-message">
                  {errors.website_url.message}
                </span>
              )}
            </div>
            <div className="form-group">
              <label>TIN/GST Number*</label>
              <input
                className="form-input"
                type="text"
                {...register("tin_gst_number", {
                  required: "TIN/GST Number is required",
                })}
              />
              {errors.tin_gst_number && (
                <span className="error-message">
                  {errors.tin_gst_number.message}
                </span>
              )}
            </div>

            <div className="form-group">
              <label>Resale Certificate Number*</label>
              <input
                className="form-input"
                type="text"
                {...register("resale_certificate_number", {
                  required: "Resale Certificate Number is required",
                })}
              />
              {errors.resale_certificate_number && (
                <span className="error-message">
                  {errors.resale_certificate_number.message}
                </span>
              )}
            </div>

            <div className="form-group">
              <label>Government License Number</label>
              <input
                className="form-input"
                type="text"
                {...register("gov_license_number")}
              />
            </div>

            {/* <div className="form-group">
      <label>Trade Reference</label>
      <input
        className="form-input"
        type="text"
        {...register("tradeReference")}
      />
    </div> */}
          </div>
        </div>

        <div className={`d-flex justify-content-end `}>
          <button type="submit" className="submit-button">
            Submit
            {updateProfileLoading && <InlineLoaderComponent />}
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditProfile;
